import { API_URL } from "./config";
import axios from 'axios';

const USER_URL = `${API_URL}/user/add-user-activity`;

export const UserActivityCreate = async (path: string): Promise<void> => {
  try {
    await axios.post(
      `${USER_URL}`,
      { path },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  } catch (error) {
    console.error('Error describing asset:', error);
    // Optional: rethrow or handle silently
    throw error;
  }
};


